import { DutyScheduleDetailResponse } from "@/api";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useDutyScheduleRecalculation } from "@/pages/duty-schedule/hooks/useDutyScheduleRecalculation";
import { useTranslation } from "@/translations";

import { DutyScheduleFormFields } from "../create-dialog/DutyScheduleFormFields";

const DIALOG_WIDTH = 750;

interface Props {
  dutySchedule: DutyScheduleDetailResponse;
  onClose: () => void;
}

/**
 * "Dienstplan bearbeiten" (edit duty schedule). Its only action recalculates: confirming saves name
 * and period and redistributes the duties against the current configuration.
 */
export function DutyScheduleEditDialog({ dutySchedule, onClose }: Props) {
  const { t } = useTranslation();
  const { formik } = useDutyScheduleRecalculation(dutySchedule, onClose);

  return (
    <FormDialog
      title={t("dutySchedule.edit.dialogTitle")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("dutySchedule.edit.submit")}
      paperSx={{ width: DIALOG_WIDTH }}
    >
      <DutyScheduleFormFields formik={formik} />
    </FormDialog>
  );
}
